const getUuidToken = async function ($cookies) {
  const token = $cookies.get('minbox_uuid');
  if (!!token) {
    return token
  }


  var d = new Date().getTime();//Timestamp
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  const newToken = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0;
      d = Math.floor(d/16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0;
      d2 = Math.floor(d2/16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });

  $cookies.set('minbox_uuid', newToken, {
    path: "/",
    maxAge: 999 * 10000 * 10000
  });

  return newToken
};

export const state = () => {};
export const actions = {
  initMindbox: async function (params) {
    const token = this.$cookies.get('minbox_uuid');
    if (!!token) {
      return
    }

    const newToken = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16))
    this.$cookies.set('minbox_uuid', newToken, {
      path: "/",
      maxAge: 999 * 10000 * 10000
    });
  },

  // product
  productCartChange: async function (params) {
    console.log('productCartChange')
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/products/cart-change', {
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },
  productProductView: async function (params, product) {
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/products/product-view', {
      "product_id": product.id,
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },
  productWishlistChange: async function (params) {
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/products/wishlist-change', {
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },

  // users
  usersAuth: async function (params) {
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/users/auth', {
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },
  usersProfileEdit: async function (params) {
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/users/edit-profile', {
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },

  // orders
  ordersCreate: async function (params, {order, isSubscribe}) {
    const isAuth = Boolean(params.rootState?.user?.user);
    const apiUrl = Boolean(isAuth) ? "/mindbox/orders/create-authorized" : "/mindbox/orders/create-unauthorized";
    const device_uuid = await getUuidToken(this.$cookies);
    return await this.$api.agent.transport.post(apiUrl, {
      "order_id": order?.id,
      "device_uuid": device_uuid,
      "subscribe": Number(isSubscribe)
    }).then(() => true).catch(() => false);
  },

  // subscriptions
  subscriptionsFooter: async function (params, { email, phone, group_id }) {
    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/subscriptions/footer-subscription', {
      "email": email,
      "phone": phone,
      "group_id": group_id,
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);
  },

  // categories
  categoriesCategoryView: async function (params, { category_id }) {
    let mindboxCategoriesIds = JSON.parse(JSON.stringify(this.$cookies.get('mindboxCategoriesIds') || []));
    if (mindboxCategoriesIds.includes(String(category_id))) {
      return
    }

    const device_uuid = await getUuidToken(this.$cookies);
    await this.$api.agent.transport.post('/mindbox/categories/category-view', {
      "category_id": category_id,
      "device_uuid": device_uuid
    }).then(() => true).catch(() => false);

    mindboxCategoriesIds.push(String(category_id));
    this.$cookies.set("mindboxCategoriesIds", JSON.stringify(mindboxCategoriesIds), {
      ...this.$getCookiesOpt(),
      maxAge:  1 * 60 * 60
    });
  },


}

export {
  getUuidToken
}
